import { Pagination } from './pagination';
import { Role } from './role';

export class User {
    id = 0;
    name = '';
    email = '';
    password = '';
    require_reset = false;
    roles: Role[] = [];
}

export class UserResponse {
    message = '';
    pagination = new Pagination;
    user = new User;
    users: User[];
}
